import { Directive } from '@angular/core';
import { FormGroup, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { difference } from 'lodash-es';

@Directive({
    selector: '[taxCreditFormValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: TaxCreditFormValidator,
            multi: true,
        },
    ],
    standalone: true,
})
export class TaxCreditFormValidator implements Validator {
    // Required fields are validated individually so can be ignored from this validation
    readonly REQUIRED_FIELDS = ['calendarYear', 'jurisdiction'];
    // Claim fields are validated based on being non-empty. All other fields are validated on being non-zero
    readonly CLAIM_FIELDS = ['claimAmount', 'personalTax'];

    validate(form: FormGroup): ValidationErrors | null {
        // All tax credit forms (federal, provincial, QC) will have either claimAmount or personalTax fields
        const hasClaimAmount = this.CLAIM_FIELDS.every((field) => {
            // these fields are validated as being non-empty NOT non-zero. We use Object.hasOwn to only validate the field if it exists
            return Object.hasOwn(form.controls, field) ? this.checkForNonEmptyString(form.controls[field].value) : true;
        });

        // For fields that are not required and not one of the claim fields, we check that at least one is non-zero
        const fields = difference(Object.keys(form.controls), [...this.REQUIRED_FIELDS, ...this.CLAIM_FIELDS]);
        return hasClaimAmount || fields.some((field) => this.checkForNonZeroValue(form.value[field]))
            ? null
            : { atLeastOneFieldRequired: true };
    }

    private checkForNonZeroValue(value: string | number): boolean {
        let numericValue = value;
        if (typeof value === 'string') {
            numericValue = Number(value.replace(/\D+/g, ''));
        }
        return value ? !!numericValue : false;
    }

    private checkForNonEmptyString(value: string): boolean {
        return value ? !!value.replace(/\s+/g, '') : false;
    }
}
